import React from 'react';
import { NavLink } from 'react-router-dom';

const links = [
  { to: '/meditation/for-you-dashboard', end: true, label: 'For You Dashboard' },
  { to: '/meditation/achievements', end: true, label: 'Achievements' },
  { to: '/meditation/sessions', end: true, label: 'Sessions' },
  { to: '/meditation', end: true, label: 'Categories' },
  { to: '/meditation/program-categories', end: true, label: 'Programs' },
];

/**
 * In-page Meditation section nav. Sidebar keeps a single "Meditation" parent entry.
 */
const MeditationNav = () => (
  <nav
    className="mb-4 md:mb-6 flex flex-wrap gap-2"
    aria-label="Meditation sections"
  >
    {links.map((link) => (
      <NavLink
        key={link.to}
        to={link.to}
        end={link.end}
        className={({ isActive }) =>
          `px-3 py-1.5 text-sm font-medium rounded-xl transition-colors ${
            isActive
              ? 'bg-brand text-white shadow-sm'
              : 'bg-white text-gray-700 border border-[#ECECEC] hover:bg-gray-50'
          }`
        }
      >
        {link.label}
      </NavLink>
    ))}
  </nav>
);

export default MeditationNav;
